module.exports = __webpack_public_path__ + "img/lg_ring_g_l_null_0@3x.f94fb4b8.png";